import { RealEstateAddress } from '../../../../@types/real-estate-api-types'
import { ContentStateInterface } from '../../../../@types/types'
import { isGermanCountryCode } from '../../../../utils/geo-utils'

type AddressSubType = Pick<
  ContentStateInterface,
  | 'addressId'
  | 'hideStreetAndStreetNumber'
  | 'addressEditable'
  | 'street'
  | 'houseNumber'
  | 'postcode'
  | 'city'
  | 'quarter'
  | 'manualCountry'
  | 'manualRegion'
  | 'manualCity'
  | 'manualQuarter'
>
export const addressToApp = (address: RealEstateAddress): AddressSubType => ({
  addressId: address.id,
  hideStreetAndStreetNumber: address.hideStreetAndStreetNumber,
  addressEditable: address.addressEditable,
  street: address.street,
  houseNumber: address.number,
  postcode: address.postcode ? address.postcode : undefined,
  city: address.city,
  manualCountry:
    address.manual?.country.id && !isGermanCountryCode(address.manual?.country.id)
      ? {
          value: String(address.manual?.country.id),
          label: null,
        }
      : undefined,
  manualRegion: {
    value: address.manual?.region.id ? String(address.manual?.region.id) : null,
    label: address.manual?.region.name ?? null,
  },
  manualCity: {
    value: address.manual?.city.id ? String(address.manual?.city.id) : null,
    label: address.manual?.city.name ?? null,
  },
  manualQuarter: {
    value: address.manual?.quarter.id ? String(address.manual?.quarter.id) : null,
    label: address.manual?.quarter.name ?? null,
    geoCoordinates: address.manual?.quarter.geoCoordinates,
  },
})
